<template>
  <ContentWrapper>
    <div div class="content-heading mt-1">
        <div>교과서명: </div>
        <div style="color:green; padding:20px;"> {{bookName}} </div>
    </div>
    <div class="card card-default">
      <div class="card-body">
        <form data-vv-scope="edit">
          <table class="table table-bordered">
            <colgroup>
              <col width="*"/>
              <col width="15%"/>
              <col width="15%"/>
              <col width="14%"/>
              <col width="14%"/>
              <col width="14%"/>
              <col width="11%"/>
            </colgroup>
            <tr>
              <!-- <td><input type="checkbox" v-model='checkedAll' @change="SelectItemAll(data.list , 'top')"></td> -->
              <td style="text-align:center" @click="localSort.sort('depth1');sliceList();">단원<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('depth2');sliceList();">차시<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('depth3');sliceList();">코너<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('contentsId');sliceList();">외부개체ID<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('contentsNm');sliceList();">개체명<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('contentsLevel3TypeCdNm');sliceList();">분류<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td style="text-align:center" @click="localSort.sort('updateDt');sliceList();">수정일<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>

          <tr v-for="(item, index) in data.list" :key="index">
            <!-- <td input-type><input type="checkbox" v-model='checked[item.contentsId]' @change="SelectItem(index,'top')" :checked="checked[item.contentsId] == true ? 'true' : 'false'"></td> -->
            <!-- <td>{{ item.contentsId.startsWith('C2') ? 'true' : 'false' }}</td> -->
            <td>{{ item.depth1 }}</td>
            <td>{{ item.depth2 }}</td>
            <td>{{ item.depth3 }}</td>
            <td>{{ item.contentsId }}</td>
            <td>{{ item.contentsNm }}</td>
            <td>{{ item.contentsLevel3TypeCdNm }}</td>
            <td>{{ item.updateDt }}</td>
          </tr>
          </table>
        </form>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="next()" @prev="prev()" @first="first()" @last="last()" :key="data.params.page"/>
        </div>
      </div>
    </div>
  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api'
import {getContentsMstList, getTextbookContentsMstList, getContentsMstItem, saveContentsMst, deleteContentsMst} from "@/api/ext/ContentsMstApi"
import {getCsFileList, getCsFileItem, saveCsFile, deleteCsFile} from "@/api/cs/CsFileApi"
import {getCsFileMappingList, getCsFileMappingItem, saveCsFileMapping, deleteCsFileMapping,saveCsFileMappingList} from "@/api/cs/CsFileMappingApi"
import {getTextbookAtrbRelInfoList} from "@/api/ext/TextbookAtrbRelInfoApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject, fileDivCd, fileDivCdMap} from "@/utils/Constants";

export default {
  components: {Pagenation},
  props: {
    bookId: '',
    bookName: '',
    totalCount: '',
    ignoreContentsIds: [],
  },
  setup(props, {root}) {
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject)

    let totalList = [];
    const ignoreIds = props.ignoreContentsIds;

    console.log('## props:',props)

    const dataAction = new TableActionClass(data);

    const getDepth1 = (item) => {
      return item.parentsTypeCdDepth1 == '1001;1' ? item.parentsTitle1
              :item.parentsTypeCdDepth2 == '1001;1' ? item.parentsTitle2
              :item.parentsTypeCdDepth3 == '1001;1' ? item.parentsTitle3
              :item.parentsTypeCdDepth4 == '1001;1' ? item.parentsTitle4 : '';
    };
    const getDepth2 = (item) => {
      return item.parentsTypeCdDepth1.startsWith('1002;') ? item.parentsTitle1
              :item.parentsTypeCdDepth2.startsWith('1002;') ? item.parentsTitle2
              :item.parentsTypeCdDepth3.startsWith('1002;') ? item.parentsTitle3
              :item.parentsTypeCdDepth4.startsWith('1002;') ? item.parentsTitle4 : '';
    };
    const getDepth3 = (item) => {
      return item.parentsTypeCdDepth1.startsWith('1003;') ? item.parentsTitle1
              :item.parentsTypeCdDepth2.startsWith('1003;') ? item.parentsTitle2
              :item.parentsTypeCdDepth3.startsWith('1003;') ? item.parentsTitle3
              :item.parentsTypeCdDepth4.startsWith('1003;') ? item.parentsTitle4 : '';
    };

    const loadData = async () => {
      // 전체리스트를 다운로드 한다.
      // if (ignoreIds.length > 0) data.params.ignoreContentsIdsStr = ignoreIds.join('-');
      data.params.textbookId = props.bookId
      data.params.limit = props.totalCount;
      data.params.page = 1;
      let _params = data.params;
      var context = {};
      context["getTextbookContentsMstList"] = getTextbookContentsMstList;  // get list
      await dataAction.execute("getTextbookContentsMstList", context, _params);
      data.list.forEach((item) => {
        item.depth1 = getDepth1(item);
        item.depth2 = getDepth2(item);
        item.depth3 = getDepth3(item);
      })

      // 이미 저장되어 있는 컨텐츠들을 걸러낸다.
      if (ignoreIds != undefined && ignoreIds.length > 0) {
        data.list = data.list.filter(row => !ignoreIds.includes(row.contentsId));
        data.count = data.list.length;
      }

      totalList = data.list; // 전체 항목 저장.
      data.params.limit = 10; // 페이지당 볼 항목 수 설정.
      first(); // go to first page.

      root.$_localSort.set(totalList);
    }
    onMounted(loadData)

    // Pagenation for Fulldata
    const next = () => { data.params.page>=lastPage()? lastPage():data.params.page++; sliceList(); }
    const prev = () => { if(data.params.page>1)data.params.page--; sliceList(); }
    const first = () => { data.params.page = 1; sliceList(); }
    const last = () => { data.params.page = lastPage(); sliceList(); }
    const lastPage = () => { let _count = data.count; let _limit = data.params.limit?data.params.limit:10; let _max = Math.ceil(_count/_limit); return _max }
    const sliceList = () => { const idx = (data.params.page-1)*data.params.limit; data.list = totalList.slice(idx, idx+data.params.limit);}

    const popupClose = () => { context.emit('modal-state', 'yfilenewlist'); }

    return {
      data,
      ignoreIds,
      next,
      prev,
      first,
      last,
      sliceList,
      popupClose,
      dataAction,
      localSort:root.$_localSort,
    }
  },
}

</script>